










































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import EventBus from '@/plugins/EventBus'
import _ from 'lodash'

@Component
export default class ModalRegraDeCalculoIncluirContrato extends Vue {
  get getRegrasDeCalculoStore() {
    return getModule(RegrasDeCalculoStore, this.$store)
  }

  get selected() { return this.getRegrasDeCalculoStore.contratosId }
  set selected(value: any) { this.getRegrasDeCalculoStore.setContratosId(value) }

  loadContratos: boolean = false
  get loadingContratos() { return this.loadContratos }
  set loadingContratos(value: boolean) { this.loadContratos = value }

  loadAddRegraCalculoOperadora: boolean = false
  get loadingPostRegraCalculoContrato() { return this.loadAddRegraCalculoOperadora }
  set loadingPostRegraCalculoContrato(value: boolean) { this.loadAddRegraCalculoOperadora = value }

  get showModalPostRegraCalculoContrato() { return this.getRegrasDeCalculoStore.modal.regraDeCalculoContrato }
  set showModalPostRegraCalculoContrato(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'regraDeCalculoContrato', value }) }

  async getContratos() {
    this.loadingContratos = true
    await this.getRegrasDeCalculoStore.getContratoByPrestador()
    this.loadingContratos = false
  }

  get contratosHeaders() {
    return [
      { text: 'Fonte pagadora', value: 'nomeFontePagadora', sortable: false },
      { text: 'Prestador', value: 'nomePrestador', sortable: false },
    ]
  }

  async postRegraCalculoContrato() {
    this.loadingPostRegraCalculoContrato = true
    const request = await this.getRegrasDeCalculoStore.postRegraCalculoContrato()
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingPostRegraCalculoContrato = false
      return
    }
    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Contraro incluído com sucesso. ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#2E7D32',
    })
    this.loadingPostRegraCalculoContrato = false
    this.showModalPostRegraCalculoContrato = false
  }

  @Watch('showModalPostRegraCalculoContrato')
  onChangeShowModalPostRegraCalculoContrato(value: boolean) {
    if (!value) {
      this.getRegrasDeCalculoStore.setPrestadorId('')
      this.getRegrasDeCalculoStore.clearContratos()
    }
  }

  validateCPFCNPJ(value) {
    if (['', null, undefined].includes(value)) return true
    const cleanedValue = value.replace(/[\.\/-]/g, '')
    if (cleanedValue.length < 11) return 'CPF inválido'
    if (cleanedValue.length === 11) return this.validateCPFCNPJ(cleanedValue) || 'CPF inválido.'
    if (cleanedValue.length > 11 && cleanedValue.length < 14) return 'CNPJ inválido.'
    if (cleanedValue.length === 14) return this.validateCPFCNPJ(cleanedValue) || 'CNPJ inválido.'
    return true
  }
}
